import BackButton from "../img/icons/icon_blue_back.svg";
import React from "react";
import { useHistory } from "react-router-dom";

const PrivacyPage = () => {
  const history = useHistory();
  return (
    <>
      <header className="border_bottom">
        <div className="inner_header">
          <div
            onClick={() => history.goBack()}
            className="icon_left d-flex align-items-center"
          >
            <img src={BackButton} alt="img" className="img-fluid" />
            <span className="head_title">Privacy Policy</span>
          </div>
        </div>
      </header>
      <div className="body_content">
        <div className="inner_body tnc">
          <div>
            {/*Section 0*/}
            <div className="summary_block">
              <p className="desc">
                This Privacy Policy governs how we, Mumbai Arthritis Clinic &
                Research centre, having its registered office at Shop 15-16,
                Mayuresh Srishti Complex, Bhandup, Rajiv Gandhi Nagar, Bhandup
                West, Mumbai, Maharashtra 400078, India (“MACR”, “we,” “us”)
                collect, use, share and process your information, that you
                provide to us through your use of the IC4.health app
                (“Platform”) in the course of availing services that are made
                available on the said app (“Services”) as defined in the Terms
                and Conditions to you.
              </p>
              <p className="desc">
                MACR respects your privacy, and seeks to comply with applicable
                legal requirements, including the Information Technology Act,
                2000, in respect of data collection, processing and transfer.
              </p>
              <p className="desc">
                Please read this Privacy Policy carefully. By accessing or using
                this Platform, you agree to be bound by the terms described
                herein and all the terms incorporated by reference. If you do
                not agree to all of these terms, do not use this Platform.
              </p>
            </div>

            {/*Section 1*/}
            <h3 className="subheadtitle">1. What is Personal Information?</h3>
            <div className="summary_block">
              <p className="desc">
                Personal information is that information which can be used to
                directly or indirectly identify you. It includes de-identified
                data that, when linked to other information available to us,
                would enable us to identify you. Personal data does not include
                data that has been irreversibly anonymised or aggregated so that
                we cannot identify you through it, even in conjugation
                conjunction with other information.
              </p>
              <p className="desc">
                "Sensitive Personal Data or Information" means personal
                information of any individual relating to password; financial
                information such as bank account or credit card or debit card or
                other payment instrument details; physical, physiological and
                mental health condition; sexual orientation; health information
                such as medical records and history; biometric information; any
                detail relating to the above as provided to or received by us
                for processing or storage. However, any data / information
                relating to an individual that is freely available or accessible
                in public domain or furnished under the Right to Information
                Act, 2005 or any other law shall not qualify as Sensitive
                Personal Data or Information.
              </p>
              <p className="desc">
                By signing up on the Platform and / or using our Services you
                represent that you voluntarily provide us with personal
                information including medical and financial information and
                consent to their collection, use and disclosure in accordance
                with this Privacy Policy. You also represent that you are duly
                authorised by any third party (including a child or an employee)
                whose information you share with us. We shall act as per your
                representation of authority and shall not make any independent
                enquiries to ascertain the veracity of your authorisation. In
                the event you do not have sufficient authorisation you shall be
                solely responsible for your acts and omissions including sharing
                of information with us by you and the consequential processing
                and actions taken by us in accordance with this Privacy Policy.
              </p>
            </div>

            {/*Section 2*/}
            <h3 className="subheadtitle">
              2. What types of data do we collect?
            </h3>
            <div className="summary_block">
              <p className="desc">
                When you sign up or register on the Platform to use our
                Services, and during the course of actual usage of our Services,
                the types of information that will be collected by us include
                the following:
              </p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    Contact information: Name, Address, Contact details, Email
                    ID, Phone Number;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Demographic information: Gender, Date of Birth;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Data regarding your usage of the Services such as search
                    history and history of the appointments made by you through
                    the use of Services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Any additional information that you provide to us during the
                    use of the Services, through any mode of communication or
                    during any interaction with our employees, doctors,
                    technicians, consultants, etc., of or any other entity in
                    the Apollo Group including while availing its services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Health information such as your medical records and history
                    which you voluntarily provide or is generated on usage of
                    any of the services availed by you;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Information regarding your physical, physiological and
                    mental health condition which you voluntarily provide or is
                    generated on usage of the Services
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Financial information such as bank account or credit card or
                    debit card or other payment instrument details and billing
                    information;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Your browsing history including the URL of the site that you
                    visited prior to visiting the Website as well as the
                    Internet Protocol (IP) address of your computer (or the
                    proxy server you used to access the World Wide Web),your
                    computer operating system and type of web browser you are
                    using, the name of your ISP;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Any other information that is collected or generated in the
                    course of availing the Services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Data regarding your medical qualifications, registrations
                    and certifications;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Any other detail relating to the above as voluntarily
                    provided to us by you, for providing value added service;
                    and
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Any other information relating to the above which you may
                    have shared with us prior to this Privacy Policy for
                    availing any of the Services
                  </span>
                </li>
              </ol>
              <p className="desc">
                The Platform uses “Cookies”. Cookies are small data files that a
                website stores on your web browser. These are used for the
                purpose of storing your preferences, previous activities
                browsing activities, profiling and tracking behaviour on this
                Website. By visiting the Platform, you acknowledge, accept and
                expressly authorize the placement of cookies on your web
                browser. We recommend that you clear the cookies stored on your
                browser from time to time.
              </p>
            </div>

            {/*Section 3*/}
            <h3 className="subheadtitle">
              3. Where do we collect your data from?
            </h3>
            <div className="summary_block">
              <p className="desc">For end users:</p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    Any information that you voluntarily choose to provide to us
                    through Platform, Website, email, during interaction with us
                    on call or chat and other modes of communication;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Information that we collect from healthcare service
                    providers (“HSPs”) such as doctors, diagnostic centres,
                    chemists etc., to whom you have permitted the sharing of
                    your personal information;
                  </span>
                </li>
              </ol>
              <p className="desc">For HSPs:</p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    Before on-boarding you, we may request information regarding
                    your qualifications, experience, public profile, and
                    representations made by you to us;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    During your usage of the Platform, we may collect
                    information based on your use of the Services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    We may collect other information that you voluntarily choose
                    to provide to us through Platform, Website, email, during
                    interaction with us on call or chat and other modes of
                    communication;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    We may collect information from any group company,
                    affiliates, associates, subsidiary, holding company of the
                    Company, associates and subsidiaries of holding company of
                    the Company to whom you have given consent for sharing of
                    information for availing value added service.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 4*/}
            <h4 className="maintitle">4. How do we use your data?</h4>
            <div className="summary_block">
              <p className="desc">
                We use your personal information for purposes that include the
                following:
              </p>
              <p className="desc">General (end users and HSPs):</p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    Your registration for the purpose of receiving our Services,
                    identification, communication, notification and for
                    fulfilment of the Terms and Conditions;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Offering you personalized Services customised health
                    insights;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Addressing your requests, queries and complaints, if any,
                    pertaining to our Services; taking feedback, assisting you
                    with completion of transactions or other issues relating to
                    the use of Services and other customer care related
                    activities;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Creating insights for corporate / business strategy and
                    marketing operations of MACR group companies;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Developing machine learning algorithms and tools to improve
                    targeting of services, diagnostics and treatment protocols
                    and other products and services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Contacting you to provide information on new Services,
                    features, products, special promotions or offers;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Technical administration and customization of Website, and
                    other general administrative and business purposes;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Research and analysis for the development and improvement of
                    products and services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Disclosure as required to government authorities in
                    compliance with applicable law;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Carrying out our obligations in relation to any agreement
                    with affiliate companies, our business partners or
                    contractors;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Investigating, enforcing and resolving any disputes or
                    grievances; and
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Any other purpose required by applicable law.
                  </span>
                </li>
              </ol>
              <p className="desc">For end users only:</p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    Creation and maintenance of health records in electronic
                    form in the Personal Health Record (PHR) database for use by
                    us and the MACR group companies, affiliates, etc., to
                    provide relevant services;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Create your unified profile with analytics and insights
                    generated through processing your personal information;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    For sharing with your chosen HSP who may provide you
                    services under the Platform;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    Processing any orders/requests you may place using our
                    Services.
                  </span>
                </li>
              </ol>
              <p className="desc">For HSPs only:</p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    For verifying your professional credentials and any
                    representations you have made to us;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    For processing any payments made to you;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    For providing recommendations to end users based on your
                    expertise and specialisations ;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    For providing any other service to you.
                  </span>
                </li>
              </ol>
            </div>

            {/*Section 5*/}
            <h3 className="subheadtitle">
              5. How long will we retain your data?
            </h3>
            <div className="summary_block">
              <p className="desc">
                We store your personal information in accordance with applicable
                laws, which means we keep your data for as long as necessary to
                provide you with our Services or as may be required under any
                law. We shall store your personal information for lawful
                purposes only. We keep de-identified data for research and
                statistical purposes for a longer period.
              </p>
              <p className="desc">
                If you close your account, we have no obligation to retain your
                data, and we may delete any or all of your data without
                liability. However, we may retain data related to you if we
                believe it may be necessary to prevent fraud or future abuse, or
                if required by law, or for other legitimate purposes. We may
                continue to store your data in anonymised or de-identified form
                for analytical, research or other purposes for which your
                information is collected as previously indicated.
              </p>
            </div>

            {/*Section 6*/}
            <h3 className="subheadtitle">
              6. Disclosure and transfer of your data
            </h3>
            <div className="summary_block">
              <p className="desc">
                We may share, disclose and in some cases transfer your personal
                information to such entities as required to provide Services to
                you, improve our Services, and to provide value added services
                or other third party products and services, to the extent
                permitted by applicable law. These entities may be located
                outside India, which you hereby consent to. We require such
                entities to protect your information through equivalent security
                measures as what we would adopt. An indicative list of entities
                we may disclose or transfer information to, are provided below:
              </p>

              <h4 className="maintitle">a. Service Providers:</h4>
              <p className="desc">
                We share personal information with companies that provide
                Services on our behalf, such as App/website hosting, data
                storage, software services, email services, marketing,
                fulfilling customer orders, providing payment related services
                including payment aggregation, data analytics, data mining,
                providing customer services, and conducting surveys, as
                permitted by applicable law. These companies may be located
                within or outside India, but in any case are obligated to
                protect your data.
              </p>
              <p className="desc">
                We may also share information with employees, data processors,
                consultants, business partners and technology partners on a need
                to know basis. Such entities would be contractually obligated to
                maintain confidentiality in relation to your data.
              </p>
              <p className="desc">
                If you are an end user, your personal information will also be
                shared with your chosen HSPs.
              </p>

              <h4 className="maintitle">b. Business Affiliates:</h4>
              <p className="desc">
                We may disclose or transfer some of your information to entities
                in the Apollo group companies, affiliates, associates,
                subsidiary, holding company of the Company, associates and
                subsidiary of holding company of the Company including foreign
                entities, and in particular group companies and affiliates who
                are involved in the provision of products and services, to the
                extent permitted by applicable law.
              </p>
              <p className="desc">
                In the event of a merger, reorganization, acquisition, joint
                venture, assignment, spin-off, transfer, asset sale, or sale or
                disposition of all or any portion of our business, including in
                connection with any bankruptcy or similar proceedings, we may
                transfer any and all personal information to the relevant third
                party with the same rights of access and use.
              </p>

              <h4 className="maintitle">c. Law Enforcement Agencies: </h4>
              <p className="desc">
                We may share information with law enforcement agencies pursuant
                to lawful requests for information, and otherwise as required
                under any law applicable at the given time, both in India and
                outside India.
              </p>

              <h4 className="maintitle">d. Other Third Parties:</h4>
              <p className="desc">
                We may also disclose personal information if we determine in
                good faith that disclosure is reasonably necessary to protect
                our rights and pursue available remedies, enforce our terms and
                conditions, investigate fraud, or protect our operations or
                users.
              </p>
              <p className="desc">
                We may disclose personal information to any third party if
                necessary to provide or improve our Services, fulfill any lawful
                contractual obligation we are bound by, and any other activity
                related to the purposes identified in this privacy policy and
                the terms and conditions you agree to when you use our Services.
              </p>
              <p className="desc">
                Anonymised, aggregated data may be shared with advertisers,
                research firms and other partners.
              </p>
            </div>

            {/*Section 7*/}
            <h3 className="subheadtitle">7. How do we protect your data?</h3>
            <div className="summary_block">
              <p className="desc">
                We are committed towards maintaining the privacy of the
                information uploaded by you on the Website and complying with
                the industry standard security safeguards for the purpose of
                securing the Website and the information provided / uploaded by
                you.
              </p>
              <p className="desc">
                We use reasonable technical, administrative, and physical
                security measures for the purpose of safeguarding all data you
                share with us. We also have comprehensive internal policies in
                place to prevent unauthorized access to your data. We take
                adequate steps to ensure that third parties we share data with
                also adopt reasonable level of security practices and procedures
                to ensure the privacy and security of your information.
              </p>
              <p className="desc">
                However, we are not responsible for any loss, unauthorised
                access, safety issue or any harm caused to you by any misuse of
                your personal information, unless it is a direct and foreseeable
                consequence of negligence and non-compliance on our part only.
                You hereby acknowledge that we are not responsible, in
                particular, for any third party action or action on your part
                leading to loss, damage or harm to you or any other person.
              </p>
              <p className="desc">
                For any data loss or theft due to unauthorized access to your
                electronic devices through which you avail our Services, Company
                shall not be held liable for any loss whatsoever incurred by
                you. Further, you are liable to indemnify the Company as per the
                Terms of Use.
              </p>
            </div>

            {/*Section 8*/}
            <h3 className="subheadtitle">8. What are your rights?</h3>
            <div className="summary_block">
              <p className="desc">
                We take reasonable steps to ensure that your personal
                information is accurate, complete, and up to date. However, you
                have the sole responsibility of ensuring that you review the
                accuracy of information provided by you and contact us in case
                of discrepancies, or in case you wish to discontinue the use of
                our Services. You have the following rights with regard to your
                personal information:
              </p>
              <p className="desc">
                You have the right to access your personal information, and
                request updation, correction and deletion. If your personal
                information changes, you may correct, delete inaccuracies, or
                amend information by making the change on the Platform or by
                contacting us through
                <a
                  href="mailto:standforas@ic4.health"
                  className="txt_color_orange"
                >
                  &nbsp;standforas@ic4.health
                </a>
              </p>
              <p className="desc">
                We will make good faith efforts to make requested changes in our
                then active databases as soon as reasonably practicable. If you
                provide any information that is untrue, inaccurate, out of date
                or incomplete (or subsequently becomes untrue, inaccurate, out
                of date or incomplete), or we have reasonable grounds to suspect
                that the information provided by you is untrue, inaccurate, out
                of date or incomplete, we may, at our sole discretion,
                discontinue the provision of the Services to you. There may be
                circumstances where we will not correct, delete or update your
                personal information, including
              </p>
              <ol className="ms-3" style={{ listStyleType: "disc" }}>
                <li>
                  <span className="desc">
                    where the personal information is opinion data that is kept
                    solely for evaluative purpose;
                  </span>
                </li>
                <li>
                  <span className="desc">
                    the personal information is in documents related to a
                    prosecution if all proceedings relating to the prosecution
                    have not been completed; and
                  </span>
                </li>
                <li>
                  <span className="desc">
                    where your information has already been processed in
                    de-identified form.
                  </span>
                </li>
              </ol>
              <p className="desc">
                You are free to not to share any medical or other information
                that you consider confidential and withdraw consent for us to
                use data that you have already provided. In the event that you
                refuse to share any information or withdraw consent to process
                information that you have previously given to us, we reserve the
                right to restrict or deny the provision of our Services for
                which we consider such information to be necessary.
              </p>
            </div>

            {/*Section 9*/}
            <h3 className="subheadtitle">
              9. Third Party Websites and Services
            </h3>
            <div className="summary_block">
              <p className="desc">
                Our Platform may contain links to third party services, and give
                you the ability to access such third-party websites, products,
                and services. Please note that you may proceed to the use of
                such third party website or service at your own risk and the
                Company will not be held liable for any outcome or harm arising
                as a result of your use of such third party websites or
                services. Please read the privacy policies of any third party
                before proceeding to use their websites, products, or services.
              </p>
            </div>

            {/*Section 10*/}
            <h3 className="subheadtitle">10. Changes to this Privacy Policy</h3>
            <div className="summary_block">
              <p className="desc">
                Any changes to our Privacy Policy will be posted on the Platform
                and will become effective as of the date of posting. Please
                review the Privacy Policy from time to time to make sure you are
                aware of any changes. If you do not agree with any such revised
                terms, please refrain from using our Services and contact us to
                close any account you may have created.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage;
